import React from 'react';
import { Target, Award, Users, TrendingUp } from 'lucide-react';

const About = () => {
  const values = [
    {
      icon: <Target size={32} />,
      title: "Misión",
      description: "Representar y proyectar el talento futbolístico a nivel nacional e internacional, garantizando el máximo desarrollo profesional de cada jugador."
    },
    {
      icon: <Award size={32} />,
      title: "Excelencia",
      description: "Compromiso absoluto con la calidad en cada gestión, negociación y asesoramiento que realizamos para nuestros representados."
    },
    {
      icon: <Users size={32} />,
      title: "Transparencia",
      description: "Relaciones basadas en la confianza, la honestidad y la comunicación constante con jugadores, clubes y colaboradores."
    },
    {
      icon: <TrendingUp size={32} />,
      title: "Desarrollo Integral",
      description: "Acompañamos al futbolista en todas las fases de su carrera, desde su formación hasta su consagración profesional."
    }
  ];

  return (
    <section id="about" className="section-standard">
      <div className="container">
        <div className="section-header">
          <h2 className="heading-2">QUIÉNES SOMOS</h2>
          <div className="title-underline"></div>
        </div>

        <div className="about-intro">
          <p className="body-large">
            <strong>Elite Internacional Sport Agency</strong> es una agencia de representación de futbolistas profesionales con sede en Sevilla, España. Desde nuestra fundación, nos hemos consolidado como referente en la gestión y proyección de talento futbolístico a nivel nacional e internacional.
          </p>
          <p className="body-medium">
            Nuestra filosofía se basa en la <strong>excelencia</strong>, la <strong>ética profesional</strong> y el <strong>compromiso absoluto</strong> con el desarrollo integral de cada jugador. Contamos con un equipo multidisciplinar de profesionales especializados en derecho deportivo, gestión financiera y relaciones internacionales.
          </p>
        </div>

        <div className="values-grid">
          {values.map((value, index) => (
            <div key={index} className="value-card">
              <div className="value-icon">{value.icon}</div>
              <h3 className="heading-5">{value.title}</h3>
              <p className="body-small">{value.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;